__turbopack_context__.v({
  "banner": "ontarioBreedRestrictionBanner-module-scss-module__P27Gbq__banner",
  "dismiss": "ontarioBreedRestrictionBanner-module-scss-module__P27Gbq__dismiss",
  "icon": "ontarioBreedRestrictionBanner-module-scss-module__P27Gbq__icon",
  "link": "ontarioBreedRestrictionBanner-module-scss-module__P27Gbq__link",
  "text": "ontarioBreedRestrictionBanner-module-scss-module__P27Gbq__text",
  "wrapper": "ontarioBreedRestrictionBanner-module-scss-module__P27Gbq__wrapper",
});
